import { ReactNode, ReactPortal, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
  className?: string;
  parent?: HTMLElement;
}

export default function Portal({
  children,
  className,
  parent = document.getElementById('modal-root') as HTMLElement,
}: PortalProps): ReactPortal {
  useEffect(() => {
    if (className) {
      className.split(' ').forEach((item) => parent.classList.add(item));
    }

    return () => {
      if (className) {
        className.split(' ').forEach((item) => parent.classList.remove(item));
      }
    };
  }, [className, parent]);

  return createPortal(children, parent);
}
